import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { initNativePush } from "@/lib/nativePush";

/** Registers native push once the user is logged in. Renders nothing. */
export default function NativePushBootstrap() {
  const { user } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (user?.id) initNativePush(navigate);
  }, [user?.id, navigate]);
  return null;
}
